import { useHistory, useLocation } from "react-router-dom";
import { useInvoice } from "./use-invoice";

export function useRefundDrawer() {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const invoiceId = queryParams.get("refund");

  const { data: invoice, ...rest } = useInvoice({
    invoiceId,
    enabled: !!invoiceId,
  });

  const handleOpen = (id) => {
    if (queryParams.has("refund")) {
      queryParams.delete("refund");
    }

    queryParams.set("refund", id);
    history.push({
      search: queryParams.toString(),
    });
  };

  const handleClose = () => {
    if (queryParams.has("refund")) {
      queryParams.delete("refund");
      history.replace({
        search: queryParams.toString(),
      });
    }
  };

  return {
    open: queryParams.has("refund"),
    invoice,
    handleClose,
    handleOpen,
    ...rest,
  };
}
